module.exports = __webpack_public_path__ + "static/media/wifi_config.6a440dc7.png";